/**
 * @file The Status cell of one fetch part. Consumer: `SignifyFetchJobPartTable`, whose column
 * `render` looks the part up on the parts proxy and hands this cell that one document.
 * The cell subscribes to its own part and to nothing else, so one part's transition repaints one
 * row of a thousand and never the table around it.
 * `Fetched` and `Inserted` are the same terminal state seen before and after the client stamped
 * `insertedAt`; the stamp is the only difference and it is what the Insert count reads too.
 */

import { FC } from 'react';
import { Tag } from 'antd';
import { useSnapshot } from 'valtio';
import type { SignifyFetchPart } from '#types';

const SignifyFetchJobPartStatusCell: FC<{ part: SignifyFetchPart }> = ({ part }) => {
  const snap = useSnapshot(part);

  if (snap.state === 'running') return <Tag color="processing">Fetching</Tag>;
  if (snap.state === 'ambiguous') return <Tag color="warning">Needs a choice</Tag>;
  if (snap.state === 'failed') return <Tag color="error">Failed</Tag>;
  if (snap.state === 'done') {
    return <Tag color="success">{snap.insertedAt === null ? 'Fetched' : 'Inserted'}</Tag>;
  }
  return <Tag>Waiting</Tag>;
};

export default SignifyFetchJobPartStatusCell;
